import { render, staticRenderFns } from "./BoardSettingsForm.vue?vue&type=template&id=74335235&scoped=true&lang=pug&"
import script from "./BoardSettingsForm.vue?vue&type=script&lang=js&"
export * from "./BoardSettingsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74335235",
  null
  
)

export default component.exports